import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { TableRow } from '@mui/material';
import documentTypeIds from 'constants/documentTypeIds';
import { emptyString } from 'constants/emptyConst';
import { FinanacedOffersInfoValue, TableCellPadding } from '../../FolderGeneralDataStyles';

export const FinancedOffersAssetItemComponent = ({ asset, t, documentTypeId }) => {
  const isModification = documentTypeId === documentTypeIds.OfferModification;
  return (
    <TableRow key={asset.id}>
      <TableCellPadding>{`${asset.quantity} x ${asset.name}`}</TableCellPadding>
      <TableCellPadding>
        <FinanacedOffersInfoValue>{`${t('NUMBER', { number: asset.value })} ${asset.currency}`}</FinanacedOffersInfoValue>
      </TableCellPadding>
      <TableCellPadding>
        <FinanacedOffersInfoValue>{`${t('NUMBER', { number: asset.totalValue })} ${asset.currency}`}</FinanacedOffersInfoValue>
      </TableCellPadding>
      <TableCellPadding>
        <FinanacedOffersInfoValue>
          {asset.optionalPrice && !isModification ? `${t('NUMBER', { number: asset.optionalPrice })} EUR` : emptyString}
        </FinanacedOffersInfoValue>
      </TableCellPadding>
      <TableCellPadding>{asset.dealerName}</TableCellPadding>
      <TableCellPadding>{asset.discount && <span>{`${t('NUMBER', { number: asset.discount })} EUR`}</span>}</TableCellPadding>
      <TableCellPadding>
        {asset.discountPercent && (
          <FinanacedOffersInfoValue>
            {`${t('PERCENT_NUMBER', {
              number: asset.discountPercent
            })}`}
          </FinanacedOffersInfoValue>
        )}
      </TableCellPadding>
      <TableCellPadding>{asset.assetType}</TableCellPadding>
      <TableCellPadding>
        {asset.isSecondHand ? t('Folder.GeneralData.FinancedOffers.Asset.SecondHand') : t('Folder.GeneralData.FinancedOffers.Asset.New')}
      </TableCellPadding>
      <TableCellPadding>{asset.chassisNumber}</TableCellPadding>
      <TableCellPadding>{asset.assetKm}</TableCellPadding>
      <TableCellPadding>{asset.fabricationYearAndMonth}</TableCellPadding>
      <TableCellPadding>{asset.agreedKm}</TableCellPadding>
    </TableRow>
  );
};

FinancedOffersAssetItemComponent.propTypes = {
  asset: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  documentTypeId: PropTypes.number.isRequired
};

export default compose(withTranslation())(FinancedOffersAssetItemComponent);
